import {Injectable} from '@angular/core';
import {AccountService} from './account.service';
import {AuthService} from './auth.service';
import {CalendarApiService} from './calendar-api.service';
import {EventsService} from './events.service';
import {GameApiService} from './game-api.service';
import {LocationsService} from './locations.service';
import {StaffService} from './staff.service';
import {CountriesService} from './countries.service';

@Injectable({
  providedIn: 'root'
})
export class BaseApiService {

  constructor(
    public accountService: AccountService,
    public authService: AuthService,
    public calendarApiService: CalendarApiService,
    public countriesService: CountriesService,
    public eventsService: EventsService,
    public gameApiService: GameApiService,
    public locationsService: LocationsService,
    public staffService: StaffService
  ) {
  }

}
